"use strict";

CompanyPublicationMassEditCtrl.$inject = [
  '$scope',
  '$stateParams',
  '$q',
  'growl',
  '$translate',
  'CompanyCategoryService',
  'CompanyPublicationWatcherService',
  'CompanyUserService',
  'CompanyPublicationService',
  'priorities',
  'groups',
  'categories'
];

function CompanyPublicationMassEditCtrl(
  $scope,
  $stateParams,
  $q,
  growl,
  $translate,
  CompanyCategoryService,
  CompanyPublicationWatcherService,
  CompanyUserService,
  CompanyPublicationService,
  priorities,
  groups,
  categories) {

  $scope.massEdit = {
    "publications": $scope.publicationsMassEdit,
    "status": "PUBLISHED",
    "watchers": [],
    "priority": null,
    "category": null,
    "groups": [],
    "removeWatchers": [],
    "removeGroups": []
  };

  var nonWatchersPromise;
  var nonRemoveWatchersPromise;
  $scope.nonWatchers = [];
  $scope.watchers = [];
  $scope.nonRemoveWatchers = [];
  $scope.removeWatchers = [];
  $scope.groups = groups;
  $scope.priorities = priorities;
  $scope.categories = categories;
  $scope.groupHidden = null;
  $scope.portals = [];
  $scope.removePortals = [];

  $scope.updateNonWatchers = function(filter) {
    var p = CompanyUserService.query({companyId: $scope.companyId, q: filter, limit: 6}).$promise.then(function(users) {
      return users.filter(function(item) {
        return !$scope.watchers.some(function(watcher) {
          return item.id === watcher.id;
        });
      });
    }).then(function(nonWatchers) {
      if(nonWatchersPromise === p) {
        $scope.nonWatchers = nonWatchers;
      }
    });
    nonWatchersPromise = p;
  };

  $scope.addWatcher = function(watcher) {
    $scope.watchers.push(watcher);
    $scope.massEdit.watchers.push(watcher.id);
    angular.element('#filterWatchers').val('');
    $scope.nonWatchers.splice($scope.nonWatchers.indexOf(watcher), 1);
  };

  $scope.deleteWatcher = function(watcher, removeWatcher) {
    if(removeWatcher){
      $scope.removeWatchers.splice($scope.removeWatchers.indexOf(watcher), 1);
      $scope.massEdit.removeWatchers.splice($scope.massEdit.removeWatchers.indexOf(watcher.id), 1);
    }else{
      $scope.watchers.splice($scope.watchers.indexOf(watcher), 1);
      $scope.massEdit.watchers.splice($scope.massEdit.watchers.indexOf(watcher.id), 1);
    }
  };

  $scope.updateNonRemoveWatchers = function(filter) {
    var p = CompanyUserService.query({companyId: $scope.companyId, q: filter, limit: 6}).$promise.then(function(users) {
      return users.filter(function(item) {
        return !$scope.removeWatchers.some(function(watcher) {
          return item.id === watcher.id;
        });
      });
    }).then(function(nonRemoveWatchers) {
      if(nonRemoveWatchersPromise === p) {
        $scope.nonRemoveWatchers = nonRemoveWatchers;
      }
    });
    nonRemoveWatchersPromise = p;
  };

  $scope.addRemoveWatcher = function(watcher) {
    $scope.removeWatchers.push(watcher);
    $scope.massEdit.removeWatchers.push(watcher.id);
    angular.element('#filterRemoveWatchers').val('');
    $scope.nonRemoveWatchers.splice($scope.nonRemoveWatchers.indexOf(watcher), 1);
  };

  $scope.savePublicationsMassEdit = function() {
    if($scope.groupHidden !== null){
      $scope.massEdit.groups.push($scope.groupHidden);
    }
    $q.all(
      angular.forEach($scope.portals, function(value){
        $scope.massEdit.groups.push(value.id);
      })
    ).then(function(){
      $q.all(
        angular.forEach($scope.removePortals, function(value){
          $scope.massEdit.removeGroups.push(value.id);
        })
      ).then(function(){
        CompanyPublicationService.updateMassEdit({companyId: $scope.companyId}, $scope.massEdit, function(){
          growl.addSuccessMessage($translate.instant('publication.mass-edit-success'));
          $scope.$hide();
          angular.forEach($scope.$parent.$parent.publications, function(value){
            value.selected = false;
          });
        }, function(){
          growl.addErrorMessage($translate.instant('publication.mass-edit-failure'));
        });
      });
    });
  };

}


angular.module('dokiv')
  .controller('CompanyPublicationMassEditCtrl', CompanyPublicationMassEditCtrl);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/publications/CompanyPublicationMassEditCtrl.js
// module id = 27
// module chunks = 0